import { cn } from '@tripleten/cn';

export const cnLoginConfigTotp = cn('login-config-totp');
